import React from 'react';
import { HashRouter as Router } from 'react-router-dom';
import CustomPathCheckInFlow from './CustomPathCheckInFlow';

const CustomPathCheckInFlowWrapper = (props) => (
  <Router basename='/'>
    <CustomPathCheckInFlow {...props} />
  </Router>
);

export default CustomPathCheckInFlowWrapper;
